import {QueryableEnum, QueryableFlag, QueryableProperty} from '../queryableProperty';
import {JobStatus} from '../../../job/data/jobStatus';
import {ObjectProperties} from './communicationProperties';
import {FlagService} from '../../../flag/services/flag.service';

export class JobProperties extends ObjectProperties {
  constructor(flagService: FlagService) {
    super();
    this.properties = [
      new QueryableProperty('customerId', 'Contact', 'customer', false),
      new QueryableProperty('title', 'Title', 'string', false),
      new QueryableProperty('id', 'Id', 'number', false),
      new QueryableProperty('assigneeId', 'Assignee', 'worker', false),
      new QueryableProperty('description', 'Description', 'string', false),
      new QueryableProperty('createdBy', 'Creator', 'worker'),
      // new QueryableProperty('parentId', 'Parent ID', 'string', false),
      new QueryableEnum('status', 'GODH.Application.Core.Entities.Job.JobStatus', 'Status', 'enum', false,
        {highlightMode: 'highlightColor'},
        [
          {name: 'To Do', value: JobStatus.ToDo, icon: 'fas fa-lg fa-times', color: 'red'},
          {name: 'Progress', value: JobStatus.InProgress, icon: 'fas fa-lg fa-cog', color: '#a66400'},
          {name: 'Done', value: JobStatus.Done, icon: 'fas fa-lg fa-check', color: 'green'},
          {name: 'Hold', value: JobStatus.OnHold, icon: 'far fa-lg fa-hand-paper', color: 'orange'}
        ]),
      new QueryableFlag(flagService, 'flagColor', 'System.Integer', 'Flag', false,
        {highlightMode: 'size'}),
      new QueryableProperty('dueDate', 'Due', 'date'),
      new QueryableProperty('modifiedDate', 'Modified', 'date'),
      new QueryableProperty('creationDate', 'Creation', 'date'),
    ];
    this.sortingPropertyName = 'creationDate';
    this.sortingDescending = true;
  }
}

